class DateHelperService {
    getDateFromEpochInSeconds(date) {
        return (new Date(date)).getTime() / 1000;
    }
}

module.exports = DateHelperService;



// WEBPACK FOOTER //
// ./src/wallet/common/date-helper.service.js